var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.089 12.4348L17.4116 8.16027L3.44987 0.400472C2.52455 -0.0939115 1.65769 -0.163298 0.897551 0.377343L13.089 12.4348ZM18.1484 17.4394L22.642 14.94C23.5191 14.4543 24 13.7662 24 13.0029C24 12.2411 23.5191 11.5516 22.6434 11.0659L18.5752 8.80644L13.9954 13.334L18.1484 17.4394ZM0.146181 1.42827C0.052625 1.71305 0 2.03107 0 2.37945V23.6365C0 24.1873 0.122792 24.6614 0.344987 25.0387L12.1813 13.3325L0.146181 1.42827ZM13.089 14.2288L1.31855 25.8699C1.54367 25.9552 1.78633 26 2.04215 26C2.49823 26 2.97332 25.867 3.45718 25.601L16.9862 18.0884L13.089 14.2288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.e41e0417174b9c9c69519fbcb51ff013.svg";
export { ForwardRef as ReactComponent };